@if (addons().length > 0) {
  <app-card>
    <div class="space-y-4">
      @for (addon of addons(); track addon.item_id) {
        <div class="flex justify-between items-baseline">
          <app-checkbox
            [label]="addon.description"
            [checked]="compareStore.selected_addon_ids().has(addon.item_id)"
            (checkedChange)="compareStore.toggleAddon(addon.item_id)">
          </app-checkbox>
          <span class="text-sm" [class.line-through]="!compareStore.selected_addon_ids().has(addon.item_id)"
                [class.opacity-40]="!compareStore.selected_addon_ids().has(addon.item_id)">
            (per tire) <span class="font-semibold">{{ addon.price_each | currency }}</span>
          </span>
        </div>
      }
    </div>
  </app-card>
}
